import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiClient from "common/src/api/ApiClient";
import {constructFilter} from "common/src/utils/AdvancedFilterApiUtils";
import {isEqual} from "lodash";
import {constructPage, constructSort} from "common/src/utils/APIUtils";
import {getKey} from "../../utils/InfiniteScroleUtil";

export const primaryKeyIdentifier = "id";

export const fetchGroupPage = createAsyncThunk(
    'group/fetch/page',
    async ({page, filter, sort}, thunkAPI) => {
        try {
            const response = await apiClient.get(`/api/v1/group`, null, page, filter, sort);
            return thunkAPI.fulfillWithValue(response.data.payload);

        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const fetchGroupDetails = createAsyncThunk(
    'group/fetch/details',
    async ({groupId}, thunkAPI) => {
        const response = await apiClient.get(`/api/v1/group/${groupId}`, null, null, null, null);
        return response.data.payload;
    }
);
export const saveGroup = createAsyncThunk(
    'group/save/details',
    async (groupData, thunkAPI) => {
        try {
            let response;
            if (groupData.id) {
                // Update group if ID is present
                response = await apiClient.put(`/api/v1/group/${groupData.id}`, groupData);
                thunkAPI.dispatch(cleanupGroupById(groupData.id));
            } else {
                // Create group if ID is not present
                response = await apiClient.post('/api/v1/group', groupData);
            }
            // Return response payload
            return thunkAPI.fulfillWithValue(response.data.payload);
        } catch (error) {
            // Dispatch error notification
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const deleteGroup = createAsyncThunk(
    'group/save/details',
    async (groupId, thunkAPI) => {
        try {
            let response = await apiClient.delete(`/api/v1/group/${groupId}`);
                thunkAPI.dispatch(cleanupGroupById(groupId));
                // Return response payload
            return thunkAPI.fulfillWithValue(response.data.payload);
        } catch (error) {
            // Dispatch error notification
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

const initialState = {
    page: {},
    statesInfinitiveScrolls: {},
    loading: false,
    error: false,
    loadingDetails: false,
    details: {},
    lastRequestId: undefined,
};

const groupAPI = createSlice({
    name: 'groupAPI',
    initialState,
    reducers: {
        cleanupGroupById: (state, action) => {
            delete state[action.payload];
            state.details = undefined;
        },
        clearGroupPage: (state) => {
            state.page = {};
            state.loading = false;
            state.error = false;
            state.lastRequestId = undefined;
        },
        clearInfiniteScroll: (state) => {
            state.statesInfinitiveScrolls = {};


        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGroupPage.pending, (state, action) => {

                state.lastRequestId = action?.meta.requestId;
                state.loading = true;
                // state.error = false;
            })
            .addCase(fetchGroupPage.fulfilled, (state, action) => {

                    if (action?.meta.arg.page !== null && action?.meta.arg.sort !== null) {

                        const sortQuery = constructSort(action?.meta.arg.sort, null);
                        const page = constructPage(action?.meta.arg.page.page, action?.meta.arg.page.size);
                        const sizeCurrent = action?.meta.arg.page.size;

                        const totalPages = action.payload.totalPages;

                        let filter = getKey(constructFilter(action?.meta.arg.filter));
                        let sort = getKey(sortQuery);

                        if (!state.statesInfinitiveScrolls) {
                            state.statesInfinitiveScrolls = {};
                        }
                        if (!state.statesInfinitiveScrolls[filter]) {
                            state.statesInfinitiveScrolls[filter] = {};
                        }
                        if (!state.statesInfinitiveScrolls[filter][sort]) {
                            state.statesInfinitiveScrolls[filter][sort] = {};
                        }
                        if (!state.statesInfinitiveScrolls[filter][sort][page]) {
                            state.statesInfinitiveScrolls[filter][sort][page] = {};
                        }
                        if (!state.statesInfinitiveScrolls[filter] ||
                            state.statesInfinitiveScrolls[filter].totalElements != action.payload.totalElements ||
                            state.statesInfinitiveScrolls[filter].totalPages != action.payload.totalPages
                        ) {

                            state.statesInfinitiveScrolls[filter] = {};
                            state.statesInfinitiveScrolls[filter].totalElements = action.payload.totalElements;
                            state.statesInfinitiveScrolls[filter].totalPages = action.payload.totalPages;
                            state.statesInfinitiveScrolls[filter][sort] = {};
                            state.statesInfinitiveScrolls[filter][sort].content = [];
                            state.statesInfinitiveScrolls[filter][sort].pages = [];

                            for (let i = 0; i < totalPages; i++) {
                                let setupPageForI = constructPage(i, sizeCurrent);
                                state.statesInfinitiveScrolls[filter][sort][setupPageForI] = {};
                                state.statesInfinitiveScrolls[filter][sort][setupPageForI].loaded = false;
                                state.statesInfinitiveScrolls[filter][sort][setupPageForI].content = [];
                                state.statesInfinitiveScrolls[filter][sort].pages = {}

                            }
                            state.statesInfinitiveScrolls[filter][sort][page] = {};
                            state.statesInfinitiveScrolls[filter][sort][page].content = action.payload.content;
                            state.statesInfinitiveScrolls[filter][sort].content = action.payload.content;
                            state.statesInfinitiveScrolls[filter][sort][page].loaded = true;

                        } else {
                            if (!state.statesInfinitiveScrolls[filter][sort]) {
                                state.statesInfinitiveScrolls[filter][sort] = {};
                                state.statesInfinitiveScrolls[filter][sort].current = []
                                for (let i = 0; i < totalPages; i++) {
                                    let setupPageForI = constructPage(i, sizeCurrent);
                                    state.statesInfinitiveScrolls[filter][sort][setupPageForI] = {};
                                    state.statesInfinitiveScrolls[filter][sort][setupPageForI].loaded = false;
                                    state.statesInfinitiveScrolls[filter][sort][setupPageForI].content = [];
                                }

                                state.statesInfinitiveScrolls[filter][sort][page] = {};
                                state.statesInfinitiveScrolls[filter][sort][page].content = action.payload.content;
                                state.statesInfinitiveScrolls[filter][sort].content = action.payload.content;
                                state.statesInfinitiveScrolls[filter][sort][page].loaded = true;
                            }  else if (!state.statesInfinitiveScrolls[filter][sort][page]) {
                                state.statesInfinitiveScrolls[filter][sort][page] = {};
                                state.statesInfinitiveScrolls[filter][sort][page].content = action.payload.content;
                                if (state.statesInfinitiveScrolls[filter][sort].content) {
                                    for (const el of action.payload.content) {
                                        const inArray = state.statesInfinitiveScrolls[filter][sort].content?.find(it => it.id === el.id);
                                        if (inArray && state.statesInfinitiveScrolls[filter][sort].content?.indexOf(inArray) > -1) {
                                            state.statesInfinitiveScrolls[filter][sort].content.splice(state.statesInfinitiveScrolls[filter][sort].content.indexOf(inArray), 1, inArray);
                                        } else {
                                            state.statesInfinitiveScrolls[filter][sort].content.push(el);
                                        }
                                    }
                                } else {
                                    state.statesInfinitiveScrolls[filter][sort].content = action.payload.content;
                                }
                                state.statesInfinitiveScrolls[filter][sort][page].loaded = true;
                            }
                            else {

                                    if (state.statesInfinitiveScrolls[filter][sort][page] &&
                                        (state.statesInfinitiveScrolls[filter][sort][page].loaded === true)
                                        && !isEqual(state.statesInfinitiveScrolls[filter][sort][page].content, action.payload.content)) {
                                        state.statesInfinitiveScrolls[filter][sort][page] = {};
                                        state.statesInfinitiveScrolls[filter][sort].content = [];

                                        for (let i = 0; i < totalPages; i++) {
                                            let setupPageForI = constructPage(i, sizeCurrent);
                                            state.statesInfinitiveScrolls[filter][sort][setupPageForI] = {};
                                            state.statesInfinitiveScrolls[filter][sort][setupPageForI].loaded = false;
                                            state.statesInfinitiveScrolls[filter][sort][setupPageForI].content = [];

                                        }
                                        state.statesInfinitiveScrolls[filter][sort][page] = {};
                                        state.statesInfinitiveScrolls[filter][sort][page].content = action.payload.content;
                                        state.statesInfinitiveScrolls[filter][sort].content = action.payload.content;
                                        state.statesInfinitiveScrolls[filter][sort][page].loaded = true;
                                    } else if (
                                        state.statesInfinitiveScrolls[filter][sort][page] &&
                                        state.statesInfinitiveScrolls[filter][sort][page].loaded === false

                                    ) {
                                        let none = true;
                                        for (const el of action.payload.content) {
                                            if (state.statesInfinitiveScrolls[filter][sort].content?.some((it) =>
                                                isEqual(it.id, el.id) && !isEqual(it, el)) === true) {
                                                none = false;
                                            }
                                        }

                                        if (none) {
                                            if (state.statesInfinitiveScrolls[filter][sort].content) {
                                                for (const el of action.payload.content) {
                                                    const inArray = state.statesInfinitiveScrolls[filter][sort].content?.find(it => it.id === el.id);
                                                    if (inArray && state.statesInfinitiveScrolls[filter][sort].content?.indexOf(inArray) > -1) {
                                                        state.statesInfinitiveScrolls[filter][sort].content.splice(state.statesInfinitiveScrolls[filter][sort].content.indexOf(inArray), 1, el);
                                                    } else {
                                                        state.statesInfinitiveScrolls[filter][sort].content.push(el);
                                                    }
                                                }
                                            } else {
                                                state.statesInfinitiveScrolls[filter][sort].content = action.payload.content;
                                            }
                                            state.statesInfinitiveScrolls[filter][sort][page].loaded = true;
                                            state.statesInfinitiveScrolls[filter][sort][page].content = action.payload.content;
                                        } else {
                                            state.statesInfinitiveScrolls[filter][sort] = {};
                                            for (let i = 0; i < totalPages; i++) {
                                                let setupPageForI = constructPage(i, sizeCurrent);
                                                state.statesInfinitiveScrolls[filter][sort][setupPageForI] = {};
                                                state.statesInfinitiveScrolls[filter][sort][setupPageForI].loaded = false;
                                                state.statesInfinitiveScrolls[filter][sort][setupPageForI].content = [];
                                            }
                                            state.statesInfinitiveScrolls[filter][sort][page] = {};
                                            state.statesInfinitiveScrolls[filter][sort][page].content = action.payload.content;
                                            state.statesInfinitiveScrolls[filter][sort].content = action.payload.content;
                                            state.statesInfinitiveScrolls[filter][sort][page].loaded = true;
                                        }

                                    } else {
                                        if (state.statesInfinitiveScrolls[filter][sort].content) {
                                            for (const el of action.payload.content) {
                                                const inArray = state.statesInfinitiveScrolls[filter][sort].content?.find(it => it.id === el.id);
                                                if (inArray && state.statesInfinitiveScrolls[filter][sort].content?.indexOf(inArray) > -1) {
                                                    state.statesInfinitiveScrolls[filter][sort].content.splice(state.statesInfinitiveScrolls[filter][sort].content.indexOf(inArray), 1, el);
                                                } else {
                                                    state.statesInfinitiveScrolls[filter][sort].content.push(el);
                                                }
                                            }
                                        } else {
                                            state.statesInfinitiveScrolls[filter][sort].content = action.payload.content;
                                        }
                                        state.statesInfinitiveScrolls[filter][sort][page].loaded = true;
                                        state.statesInfinitiveScrolls[filter][sort][page].content = action.payload.content;
                                    }
                                }
                            }

                        state.statesInfinitiveScrolls[filter].totalElements = action.payload.totalElements;
                        state.statesInfinitiveScrolls[filter].totalPages = action.payload.totalPages;

                    }
                if (state.lastRequestId === action?.meta?.requestId) {
                    state.page = action.payload;
                    state.loading = false;
                }
                }
            )
            .addCase(fetchGroupPage.rejected, (state, action) => {
                if (state.lastRequestId === action.meta?.requestId) {
                    state.loading = false;
                    state.page = null;
                }
            })
            .addCase(fetchGroupDetails.fulfilled, (state, action) => {
                state.details = action.payload;
                state[action.payload.id] = action.payload;
            })
            .addCase(fetchGroupDetails.pending, (state, action) => {
                state.detailsLoading = true;
            })
            .addCase(fetchGroupDetails.rejected, (state, action) => {
                state.detailsLoading = false;
            })
            .addCase(saveGroup.fulfilled, (state, action) => {
                if (!state.page) {
                    state.page = {};
                }
                state.page.content = [];
                state.page.last = false;
                state.loading = true;
            })
        ;
    },
});

export const {cleanupGroupById, clearInfiniteScroll} = groupAPI.actions;


export default groupAPI.reducer;
